'use client'

import { ReactNode } from 'react'
import { InView } from 'react-intersection-observer'

import { useAbTest, useTrackAbTestCallback } from '@marketplace-web/feature-flags/ab-tests-data'

type Props = {
  children: ReactNode
}

const GalleryReworkWrapper = ({ children }: Props) => {
  const galleryRework = useAbTest('web_item_page_gallery_rework')
  const trackAbTest = useTrackAbTestCallback()

  const handleInViewChange = (inView: boolean) => {
    if (!inView) return

    trackAbTest(galleryRework)
  }

  return (
    <InView as="div" onChange={handleInViewChange} triggerOnce>
      {children}
    </InView>
  )
}

export default GalleryReworkWrapper
